import { createAction } from 'redux-act';

export const updateLocationHistoryAction = createAction('Store users browser history');
export const changeLanguageAction = createAction('Change app language'); 
export const updateAppPathAction = createAction('Update app state value by path', (path: string, data: any) => ({ path, data }));
export const archiveLinkAction = createAction('Archive link');

